import { newOrderStatus, orderRefundStatus, refundmentType, refundReturn, onlyRefundReason, sendGoodsStutes, channelOptions } from 'json/goods-order-options'
// 商品订单状态枚举查询
export function getOrderStatus (val) {
  let label
  newOrderStatus.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 退款状态枚举查询
export function getOrderRefundStatus (val) {
  let label
  orderRefundStatus.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 退款方式枚举查询
export function getRefundmentType (val) {
  let label
  refundmentType.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 退款退货的退款原因枚举查询
export function getRefundReturn (val) {
  let label
  refundReturn.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 仅退款的退款原因枚举查询
export function getOnlyRefundReason (val) {
  let label
  onlyRefundReason.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 收货状态枚举查询
export function getSendGoods (val) {
  let label
  sendGoodsStutes.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 订单支付方式枚举查询
export function getChannelName (val) {
  let label
  channelOptions.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
